import React, { useState, useEffect } from 'react'
import {
  Table,
  Button,
  Modal,
  Input,
  Space,
  Switch,
} from 'antd'
import {
  EditOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import axios from 'axios'
import { toast } from 'react-toastify'
import { BranchMasterById,RegControlOfBranchMaster } from '../../AllAPI/AdminAPI'

const RegistrationControl = () => {

  const BranchId = sessionStorage.getItem('selected_branch')
  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [loading, setLoading] = useState(false)

  // --- FORM STATES USING useState ---
  const [selectedBranchId, setSelectedBranchId] = useState('')

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingId, setEditingId] = useState(null)

  const [modalStatus, setModalStatus] = useState(true)
  const [updatingStatus, setUpdatingStatus] = useState(false)

  useEffect(() => {
    fetchBranchName()
  }, [])

  const fetchBranchName = async () => {
    setLoading(true)
    try {
      const res = await axios.get(`${BranchMasterById}/${BranchId}`)

      const formatted = res.data.map((item, index) => ({
        key: item.room_id,
        index: index + 1,
        branch_id: item.branch_id,
        branch_name: item.branch_name,
        status: item.status === 1 ? 'Active' : 'Inactive',
      }))

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load rooms')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }

  // --- OPEN MODAL ---
  const handleOpenModal = (record = null) => {
    
    if (record) {
      setModalStatus(record.status === 'Active')
      setSelectedBranchId(record.branch_id)
    } else {
      setModalStatus(true);
    }
    setIsModalOpen(true)
  }


  const handleModalStatusChange = async (checked) => {
    setModalStatus(checked)
    setUpdatingStatus(true)    

    try {
      const payload = {
        status: checked ? 1 : 2,
      }

      await axios.put(`${RegControlOfBranchMaster}/${selectedBranchId}`, payload)
      toast.success('Registration Status Updated')
      setIsModalOpen(false)
      fetchBranchName();

      // update UI table instantly
      setData((prev) =>
        prev.map((item) =>
          item.key === editingId
            ? { ...item, status: checked ? 'Active' : 'Inactive' }
            : item,
        ),
      )
    } catch (err) {
      toast.error('Failed to update status')
    } finally {
      setUpdatingStatus(false)
    }
  }

  // --- SEARCH ---
  const filteredData = data.filter((item) =>
    ((item.branch_name ?? '') + '')
      .toLowerCase()
      .includes(searchText.toLowerCase()),
  )

  const columns = [
    { title: 'Sr No', dataIndex: 'index' },
    { title: 'Branch Name', dataIndex: 'branch_name' },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (_, record) => (
        <span
          style={{
            padding: '4px 10px',
            borderRadius: '15px',
            fontWeight: '600',
            color: record.status === 'Active' ? 'green' : 'red',
            background: record.status === 'Active' ? '#e8ffe8' : '#ffe8e8',
          }}
        >
          {record.status === 'Active' ? 'ON' : 'OFF'}
        </span>
      ),
    },
    {
      title: 'Actions',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            size="small"
            onClick={() => handleOpenModal(record)}
          />
        </Space>
      ),
    },
  ]

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Site Setting</h2>
          </div>

          <div className="search-bar">
            <Input
              placeholder="Search Branch..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table className="shadow"
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>

      <Modal
        title="Registration Status Update"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsModalOpen(false)}>
            Cancel
          </Button>,
        ]}
      >

          <div className='py-3'>
            <label>Status : &nbsp;</label>
            <Switch
              checked={modalStatus}
              loading={updatingStatus}
              onChange={handleModalStatusChange}
              checkedChildren="ON"
              unCheckedChildren="OFF"
            />
          </div>
     
      </Modal>
    </div>
  )
}

export default RegistrationControl
